<app-auth-modal
  [standalone]="true"
  [view]="mode"
  [caller]="getParam('caller')"
  [reason]="getParam('reason')"
  (modeChanged)="mode = $event"
  (authSucceed)="onAuthSucceed()"
  (authCanceled)="onAuthCanceled()"
></app-auth-modal>
